var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "nestedForm",
      attrs: { "lazy-validation": "" },
      on: {
        input: function($event) {
          return _vm.onChangeValidation(_vm.valid)
        }
      },
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c(
        "div",
        { staticClass: "va-card" },
        [
          _c("div", { staticClass: "va-subtitle-s mb-6" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("policiesGroups.appearance")) +
                " " +
                _vm._s(_vm.$t("common.settings")) +
                " - "
            ),
            _c("img", {
              staticClass: "mx-2",
              staticStyle: { width: "20px", display: "inline" },
              attrs: {
                src: require("@/assets/images/deviceTypes/microsoft.svg"),
                alt: "windows logo"
              }
            }),
            _c("img", {
              staticClass: "mr-2",
              staticStyle: { width: "20px", display: "inline" },
              attrs: {
                src: require("@/assets/images/deviceTypes/android.svg"),
                alt: "android logo"
              }
            }),
            _c("span", { staticClass: "font-weight-medium font-italic" }, [
              _vm._v(" (" + _vm._s(_vm.$t("policiesGroups.winAndroid")) + ")")
            ])
          ]),
          _c("v-divider", { staticClass: "mb-4" }),
          _c(
            "section",
            { staticClass: "interface-customization" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("homeLauncherConfiguration.userInterfaceTitle")
                    ) +
                    " "
                )
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("homeLauncherConfiguration.customLogoActive"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.CustomLogoActive,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "CustomLogoActive", $$v)
                  },
                  expression: "fields.CustomLogoActive"
                }
              }),
              _vm.fields.CustomLogoActive
                ? _c("file-uploader", {
                    staticClass: "mt-4",
                    attrs: {
                      files: _vm.fields.Logo ? [_vm.fields.Logo] : [],
                      title: _vm.$t(
                        "homeLauncherConfiguration.customLogoUploader"
                      ),
                      accept: [".png", ".jpg"],
                      "file-type": 2,
                      disabled: !_vm.isAdmin
                    },
                    on: { upload: _vm.uploadLogo }
                  })
                : _vm._e(),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t(
                    "homeLauncherConfiguration.customBackgroundActive"
                  ),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.CustomBackgroundActive,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "CustomBackgroundActive", $$v)
                  },
                  expression: "fields.CustomBackgroundActive"
                }
              }),
              _vm.fields.CustomBackgroundActive
                ? _c("file-uploader", {
                    staticClass: "mt-4",
                    attrs: {
                      files: _vm.fields.Backgrounds
                        ? _vm.fields.Backgrounds
                        : [],
                      title: _vm.$t(
                        "homeLauncherConfiguration.customBackgroundUploader"
                      ),
                      multiple: "",
                      accept: [".png", ".jpg", ".jpeg"],
                      "file-type": 1,
                      disabled: !_vm.isAdmin
                    },
                    on: { upload: _vm.uploadBackgrounds }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "section",
            { staticClass: "wifi" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("homeLauncherConfiguration.wifiTitle")) +
                    " "
                )
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("homeLauncherConfiguration.showWifiData"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.ShowWifiData,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "ShowWifiData", $$v)
                  },
                  expression: "fields.ShowWifiData"
                }
              }),
              _vm.fields.ShowWifiData
                ? [
                    _c("va-text-field", {
                      staticClass: "mt-4",
                      attrs: {
                        label: _vm.$t("homeLauncherConfiguration.wifiSSID"),
                        rules: [_vm.required],
                        disabled: !_vm.isAdmin
                      },
                      on: { input: _vm.onChange },
                      model: {
                        value: _vm.fields.WifiSSID,
                        callback: function($$v) {
                          _vm.$set(_vm.fields, "WifiSSID", $$v)
                        },
                        expression: "fields.WifiSSID"
                      }
                    }),
                    _c("va-text-field", {
                      staticClass: "mt-4",
                      attrs: {
                        label: _vm.$t("homeLauncherConfiguration.wifiPassword"),
                        rules: [_vm.required],
                        disabled: !_vm.isAdmin
                      },
                      on: { input: _vm.onChange },
                      model: {
                        value: _vm.fields.WifiPassword,
                        callback: function($$v) {
                          _vm.$set(_vm.fields, "WifiPassword", $$v)
                        },
                        expression: "fields.WifiPassword"
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          ),
          _c(
            "section",
            { staticClass: "interface-customization" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("homeLauncherConfiguration.wtcTitle")) +
                    " "
                )
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("homeLauncherConfiguration.CustomWtcLogoActive"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.CustomWtcLogoActive,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "CustomWtcLogoActive", $$v)
                  },
                  expression: "fields.CustomWtcLogoActive"
                }
              }),
              _vm.fields.CustomWtcLogoActive
                ? _c("file-uploader", {
                    staticClass: "mt-4",
                    attrs: {
                      files: _vm.fields.WtcLogo ? [_vm.fields.WtcLogo] : [],
                      title: _vm.$t("homeLauncherConfiguration.WtcLogo"),
                      accept: [".png", ".jpg", ".jpeg"],
                      "file-type": 2,
                      disabled: !_vm.isAdmin
                    },
                    on: { upload: _vm.uploadWtcLogo }
                  })
                : _vm._e(),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t(
                    "homeLauncherConfiguration.CustomWtcBackgroundActive"
                  ),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.CustomWtcBackgroundActive,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "CustomWtcBackgroundActive", $$v)
                  },
                  expression: "fields.CustomWtcBackgroundActive"
                }
              }),
              _vm.fields.CustomWtcBackgroundActive
                ? _c("file-uploader", {
                    staticClass: "mt-4",
                    attrs: {
                      files: _vm.fields.WtcBackground
                        ? [_vm.fields.WtcBackground]
                        : [],
                      title: _vm.$t("homeLauncherConfiguration.WtcBackground"),
                      accept: [".png", ".jpg", ".jpeg"],
                      "file-type": 1,
                      disabled: !_vm.isAdmin
                    },
                    on: { upload: _vm.uploadWtcBackground }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "section",
            { staticClass: "digital-signage" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("homeLauncherConfiguration.digitalSignageTitle")
                    ) +
                    " "
                )
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("homeLauncherConfiguration.digitalSignageActive")
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.DigitalSignageActive,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "DigitalSignageActive", $$v)
                  },
                  expression: "fields.DigitalSignageActive"
                }
              }),
              _vm.fields.DigitalSignageActive
                ? _c(
                    "div",
                    { staticClass: "d-flex mt-4" },
                    [
                      _c("va-text-field", {
                        key: "playlist-url-" + _vm.playlistUrlVersion,
                        staticClass: "flex-grow-1 mr-8",
                        attrs: {
                          label: _vm.$t(
                            "homeLauncherConfiguration.webUrlBackground"
                          ),
                          rules: [_vm.required]
                        },
                        model: {
                          value: _vm.playlistUrl,
                          callback: function($$v) {
                            _vm.playlistUrl = $$v
                          },
                          expression: "playlistUrl"
                        }
                      }),
                      _c("va-button", {
                        attrs: { size: "xl", cta: _vm.$t("ds.chosePlaylist") },
                        on: {
                          click: function($event) {
                            _vm.playlistDialog = true
                          }
                        }
                      }),
                      _c(
                        "v-dialog",
                        {
                          attrs: { "content-class": "va-dialog" },
                          model: {
                            value: _vm.playlistDialog,
                            callback: function($$v) {
                              _vm.playlistDialog = $$v
                            },
                            expression: "playlistDialog"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", [
                                _c("div", { staticClass: "va-title" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("ds.chosePlaylist")) +
                                      " "
                                  )
                                ])
                              ]),
                              _c(
                                "v-card-text",
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      outlined: "",
                                      clearable: "",
                                      items: _vm.availablePlaylist,
                                      "item-text": "name",
                                      "item-value": "value",
                                      label: _vm.$t("ds.chosePlaylist"),
                                      "return-object": "",
                                      "hide-details": "auto"
                                    },
                                    on: { change: _vm.onChosePlaylist }
                                  }),
                                  _c("div", { staticClass: "mt-8" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("ds.chosePlaylistDescription")
                                        ) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.fields.DigitalSignageActive
                ? _c("div", { staticClass: "text-sm ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "homeLauncherConfiguration.DigitalSignageYtDisclaimer"
                          )
                        ) +
                        " "
                    )
                  ])
                : _vm._e(),
              _vm.fields.DigitalSignageActive
                ? _c("va-switch", {
                    attrs: {
                      text: _vm.$t(
                        "homeLauncherConfiguration.DigitalSignageImmediately"
                      )
                    },
                    on: { input: _vm.onChange },
                    model: {
                      value: _vm.fields.DigitalSignageImmediately,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "DigitalSignageImmediately", $$v)
                      },
                      expression: "fields.DigitalSignageImmediately"
                    }
                  })
                : _vm._e(),
              _vm.fields.DigitalSignageActive
                ? _c("v-select", {
                    staticClass: "mt-6",
                    attrs: {
                      outlined: "",
                      dense: "",
                      attach: "",
                      items: _vm.idleTimeOptions,
                      "item-text": "text",
                      "item-value": "value",
                      label: _vm.$t(
                        "homeLauncherConfiguration.digitalSignageMaxIdleTime"
                      ),
                      "hide-details": ""
                    },
                    on: { change: _vm.onChange },
                    model: {
                      value: _vm.fields.MaxIdleTime,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "MaxIdleTime", $$v)
                      },
                      expression: "fields.MaxIdleTime"
                    }
                  })
                : _vm._e(),
              _vm.fields.DigitalSignageActive
                ? _c("v-select", {
                    staticClass: "mt-6",
                    attrs: {
                      outlined: "",
                      dense: "",
                      attach: "",
                      items: _vm.digitalSignageQrCodeModeOptions,
                      "item-text": "text",
                      "item-value": "value",
                      label: _vm.$t(
                        "homeLauncherConfiguration.DigitalSignageQrCodeMode"
                      ),
                      "hide-details": ""
                    },
                    on: { change: _vm.onChange },
                    model: {
                      value: _vm.fields.DigitalSignageQrCodeMode,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "DigitalSignageQrCodeMode", $$v)
                      },
                      expression: "fields.DigitalSignageQrCodeMode"
                    }
                  })
                : _vm._e(),
              _vm.fields.DigitalSignageActive
                ? _c("v-select", {
                    staticClass: "mt-6",
                    attrs: {
                      outlined: "",
                      dense: "",
                      attach: "",
                      items: _vm.digitalSignageQrCodePositionOptions,
                      "item-text": "text",
                      "item-value": "value",
                      label: _vm.$t(
                        "homeLauncherConfiguration.DigitalSignageQrCodePosition"
                      ),
                      "hide-details": ""
                    },
                    on: { change: _vm.onChange },
                    model: {
                      value: _vm.fields.DigitalSignageQrCodePosition,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.fields,
                          "DigitalSignageQrCodePosition",
                          $$v
                        )
                      },
                      expression: "fields.DigitalSignageQrCodePosition"
                    }
                  })
                : _vm._e(),
              _vm.fields.DigitalSignageActive &&
              _vm.fields.DigitalSignageQrCodeMode != 0
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "mt-4" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "homeLauncherConfiguration.DigitalSignageQrCodeMargin"
                              )
                            ) +
                            " "
                        )
                      ]),
                      _c(
                        "v-row",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-col",
                            [
                              _c("va-text-field", {
                                attrs: {
                                  number: "",
                                  label: _vm.$t(
                                    "homeLauncherConfiguration.left"
                                  ),
                                  rules: [
                                    _vm.maxNumber(
                                      _vm.DigitalSignageQrCodeMargin.left,
                                      9999
                                    )
                                  ]
                                },
                                on: { input: _vm.onChangeMargins },
                                model: {
                                  value: _vm.DigitalSignageQrCodeMargin.left,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.DigitalSignageQrCodeMargin,
                                      "left",
                                      $$v
                                    )
                                  },
                                  expression: "DigitalSignageQrCodeMargin.left"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("va-text-field", {
                                attrs: {
                                  number: "",
                                  label: _vm.$t(
                                    "homeLauncherConfiguration.top"
                                  ),
                                  rules: [
                                    _vm.maxNumber(
                                      _vm.DigitalSignageQrCodeMargin.top,
                                      9999
                                    )
                                  ]
                                },
                                on: { input: _vm.onChangeMargins },
                                model: {
                                  value: _vm.DigitalSignageQrCodeMargin.top,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.DigitalSignageQrCodeMargin,
                                      "top",
                                      $$v
                                    )
                                  },
                                  expression: "DigitalSignageQrCodeMargin.top"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("va-text-field", {
                                attrs: {
                                  number: "",
                                  label: _vm.$t(
                                    "homeLauncherConfiguration.right"
                                  ),
                                  rules: [
                                    _vm.maxNumber(
                                      _vm.DigitalSignageQrCodeMargin.right,
                                      9999
                                    )
                                  ]
                                },
                                on: { input: _vm.onChangeMargins },
                                model: {
                                  value: _vm.DigitalSignageQrCodeMargin.right,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.DigitalSignageQrCodeMargin,
                                      "right",
                                      $$v
                                    )
                                  },
                                  expression: "DigitalSignageQrCodeMargin.right"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("va-text-field", {
                                attrs: {
                                  number: "",
                                  label: _vm.$t(
                                    "homeLauncherConfiguration.bottom"
                                  ),
                                  rules: [
                                    _vm.maxNumber(
                                      _vm.DigitalSignageQrCodeMargin.bottom,
                                      9999
                                    )
                                  ]
                                },
                                on: { input: _vm.onChangeMargins },
                                model: {
                                  value: _vm.DigitalSignageQrCodeMargin.bottom,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.DigitalSignageQrCodeMargin,
                                      "bottom",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "DigitalSignageQrCodeMargin.bottom"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "section",
            { staticClass: "home-web-panel" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("homeLauncherConfiguration.homeWebPanelTitle")
                    ) +
                    " "
                )
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("homeLauncherConfiguration.activateHomeWebPanel")
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.HomeWebPanelEnabled,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "HomeWebPanelEnabled", $$v)
                  },
                  expression: "fields.HomeWebPanelEnabled"
                }
              }),
              _vm.fields.HomeWebPanelEnabled
                ? _c("va-text-field", {
                    staticClass: "flex-grow-1 mr-8",
                    attrs: {
                      label: _vm.$t(
                        "homeLauncherConfiguration.homeWebPanelUrl"
                      ),
                      rules: [_vm.required, _vm.url]
                    },
                    on: { input: _vm.onChange },
                    model: {
                      value: _vm.fields.HomeWebPanelUrl,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "HomeWebPanelUrl", $$v)
                      },
                      expression: "fields.HomeWebPanelUrl"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "section",
            { staticClass: "crestron" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("homeLauncherConfiguration.crestron")) +
                    " "
                )
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("homeLauncherConfiguration.crestronEnabled"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.CrestronEnabled,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "CrestronEnabled", $$v)
                  },
                  expression: "fields.CrestronEnabled"
                }
              }),
              _vm.fields.CrestronEnabled
                ? _c("va-text-field", {
                    staticClass: "mt-4",
                    attrs: {
                      label: _vm.$t("homeLauncherConfiguration.crestronUrl"),
                      rules: [_vm.required, _vm.url],
                      disabled: !_vm.isAdmin
                    },
                    on: { input: _vm.onChange },
                    model: {
                      value: _vm.fields.CrestronUrl,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "CrestronUrl", $$v)
                      },
                      expression: "fields.CrestronUrl"
                    }
                  })
                : _vm._e(),
              _vm.fields.CrestronEnabled
                ? _c("va-text-field", {
                    staticClass: "mt-4",
                    attrs: {
                      label: _vm.$t(
                        "homeLauncherConfiguration.crestronUsername"
                      ),
                      disabled: !_vm.isAdmin
                    },
                    on: { input: _vm.onChange },
                    model: {
                      value: _vm.fields.CrestronUsername,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "CrestronUsername", $$v)
                      },
                      expression: "fields.CrestronUsername"
                    }
                  })
                : _vm._e(),
              _vm.fields.CrestronEnabled
                ? _c("va-text-field", {
                    staticClass: "mt-4",
                    attrs: {
                      label: _vm.$t(
                        "homeLauncherConfiguration.crestronPassword"
                      ),
                      password: "",
                      disabled: !_vm.isAdmin
                    },
                    on: { input: _vm.onChange },
                    model: {
                      value: _vm.fields.CrestronPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "CrestronPassword", $$v)
                      },
                      expression: "fields.CrestronPassword"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "va-card mt-6" },
        [
          _c("div", { staticClass: "va-subtitle-s mb-6" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("policiesGroups.appearance")) +
                " " +
                _vm._s(_vm.$t("common.settings")) +
                " - "
            ),
            _c("img", {
              staticClass: "mx-2",
              staticStyle: { width: "20px", display: "inline" },
              attrs: {
                src: require("@/assets/images/deviceTypes/android.svg"),
                alt: "windows logo"
              }
            }),
            _c("span", { staticClass: "font-weight-medium font-italic" }, [
              _vm._v(" (" + _vm._s(_vm.$t("policiesGroups.androidOnly")) + ") ")
            ])
          ]),
          _c("v-divider", { staticClass: "mb-4" }),
          _c(
            "section",
            { staticClass: "android-only" },
            [
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.QrCodeToggleDefault"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.QrCodeToggleDefault,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "QrCodeToggleDefault", $$v)
                  },
                  expression: "fields.QrCodeToggleDefault"
                }
              }),
              _c(
                "div",
                { staticClass: "mt-n3 mb-6 secondary--text text--darken-2" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("policiesFields.QrCodeToggleDescription")) +
                      " "
                  )
                ]
              ),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  dense: "",
                  attach: "",
                  items: _vm.topBarIdleTimeOptions,
                  "item-text": "text",
                  "item-value": "value",
                  label: _vm.$t("policiesFields.TopBarIdleTime"),
                  "hide-details": ""
                },
                on: { change: _vm.onChange },
                model: {
                  value: _vm.fields.TopBarIdleTime,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "TopBarIdleTime", $$v)
                  },
                  expression: "fields.TopBarIdleTime"
                }
              }),
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(" " + _vm._s(_vm.$t("policiesFields.neatShare")) + " ")
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.IsNeatShareEnabled"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.IsNeatShareEnabled,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "IsNeatShareEnabled", $$v)
                  },
                  expression: "fields.IsNeatShareEnabled"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "va-card mt-6" },
        [
          _c("div", { staticClass: "va-subtitle-s mb-6" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("policiesGroups.appearance")) +
                " " +
                _vm._s(_vm.$t("common.settings")) +
                " - "
            ),
            _c("img", {
              staticClass: "mx-2",
              staticStyle: { width: "20px", display: "inline" },
              attrs: {
                src: require("@/assets/images/deviceTypes/microsoft.svg"),
                alt: "windows logo"
              }
            }),
            _c("span", { staticClass: "font-weight-medium font-italic" }, [
              _vm._v(" (" + _vm._s(_vm.$t("policiesGroups.winOnly")) + ") ")
            ])
          ]),
          _c("v-divider", { staticClass: "mb-4" }),
          _c(
            "section",
            { staticClass: "voice-commands" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("policiesFields.VoiceCommands")) + " "
                )
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.VoiceCommandsActive"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.VoiceCommandsActive,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "VoiceCommandsActive", $$v)
                  },
                  expression: "fields.VoiceCommandsActive"
                }
              }),
              _vm.fields.VoiceCommandsActive
                ? [
                    _c("v-select", {
                      staticClass: "mt-4",
                      attrs: {
                        outlined: "",
                        dense: "",
                        attach: "",
                        items: _vm.languagesOptions,
                        "item-text": "text",
                        "item-value": "value",
                        label: _vm.$t("policiesFields.VoiceCommandsCultureKey"),
                        "hide-details": "",
                        rules: [_vm.required],
                        disabled: !_vm.isAdmin
                      },
                      on: { change: _vm.onChange },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("v-img", {
                                  staticClass: "mr-2",
                                  attrs: { "max-width": "20", src: item.icon }
                                }),
                                _vm._v(" " + _vm._s(item.text) + " ")
                              ]
                            }
                          },
                          {
                            key: "item",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("v-img", {
                                  staticClass: "mr-2",
                                  attrs: { "max-width": "20", src: item.icon }
                                }),
                                _vm._v(" " + _vm._s(item.text) + " ")
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        574943004
                      ),
                      model: {
                        value: _vm.fields.VoiceCommandsCultureKey,
                        callback: function($$v) {
                          _vm.$set(_vm.fields, "VoiceCommandsCultureKey", $$v)
                        },
                        expression: "fields.VoiceCommandsCultureKey"
                      }
                    }),
                    _c("va-switch", {
                      attrs: {
                        text: _vm.$t("policiesFields.DisableVoiceSuggestion"),
                        disabled: !_vm.isAdmin
                      },
                      on: { input: _vm.onChange },
                      model: {
                        value: _vm.fields.DisableVoiceSuggestion,
                        callback: function($$v) {
                          _vm.$set(_vm.fields, "DisableVoiceSuggestion", $$v)
                        },
                        expression: "fields.DisableVoiceSuggestion"
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          ),
          _c(
            "section",
            { staticClass: "auto-hide-menu" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("policiesFields.AutoHideMainTaskBarTitle")) +
                    " "
                )
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.AutoHideMainTaskBarDescription"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.AutoHideMainTaskBar,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "AutoHideMainTaskBar", $$v)
                  },
                  expression: "fields.AutoHideMainTaskBar"
                }
              }),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.HideMicrophone"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.HideMicrophone,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "HideMicrophone", $$v)
                  },
                  expression: "fields.HideMicrophone"
                }
              }),
              _c(
                "div",
                { staticClass: "mt-n3 mb-6 secondary--text text--darken-2" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("policiesFields.HideMicrophoneDescription")
                      ) +
                      " "
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "section",
            { staticClass: "people-count" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("homeLauncherConfiguration.peopleCountTitle")
                    ) +
                    " "
                )
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("homeLauncherConfiguration.peopleCountDescription")
                  ) +
                  " "
              ),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("homeLauncherConfiguration.peopleCountEnabled"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.PeopleCountEnabled,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "PeopleCountEnabled", $$v)
                  },
                  expression: "fields.PeopleCountEnabled"
                }
              }),
              _vm.fields.PeopleCountEnabled
                ? _c("va-text-field", {
                    staticClass: "mt-4",
                    attrs: {
                      number: "",
                      label: _vm.$t(
                        "homeLauncherConfiguration.peopleCountRoomCapacity"
                      ),
                      rules: [
                        _vm.required,
                        _vm.minNumber(_vm.fields.PeopleCountRoomCapacity, 1),
                        _vm.maxNumber(_vm.fields.PeopleCountRoomCapacity, 30)
                      ],
                      disabled: !_vm.isAdmin
                    },
                    on: { input: _vm.onChange },
                    model: {
                      value: _vm.fields.PeopleCountRoomCapacity,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "PeopleCountRoomCapacity", $$v)
                      },
                      expression: "fields.PeopleCountRoomCapacity"
                    }
                  })
                : _vm._e(),
              _vm.fields.PeopleCountEnabled
                ? _c("va-switch", {
                    attrs: {
                      text: _vm.$t(
                        "homeLauncherConfiguration.peopleCountOnScreenNotification"
                      ),
                      disabled: !_vm.isAdmin
                    },
                    on: { input: _vm.onChange },
                    model: {
                      value: _vm.fields.PeopleCountOnScreenNotification,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.fields,
                          "PeopleCountOnScreenNotification",
                          $$v
                        )
                      },
                      expression: "fields.PeopleCountOnScreenNotification"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "section",
            { staticClass: "restart" },
            [
              _c("div", { staticClass: "va-subtitle-s mt-6" }, [
                _vm._v(" " + _vm._s(_vm.$t("policiesFields.Settings")) + " ")
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.ShowCameraSettings"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.ShowCameraSettings,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "ShowCameraSettings", $$v)
                  },
                  expression: "fields.ShowCameraSettings"
                }
              }),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.ShowSettings"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.ShowSettings,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "ShowSettings", $$v)
                  },
                  expression: "fields.ShowSettings"
                }
              }),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.ShowRestartDevice"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.ShowRestartDevice,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "ShowRestartDevice", $$v)
                  },
                  expression: "fields.ShowRestartDevice"
                }
              }),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.ShowRestartSoftware"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.ShowRestartSoftware,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "ShowRestartSoftware", $$v)
                  },
                  expression: "fields.ShowRestartSoftware"
                }
              }),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.ShowDisplaySwitch"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.ShowDisplaySwitch,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "ShowDisplaySwitch", $$v)
                  },
                  expression: "fields.ShowDisplaySwitch"
                }
              }),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.StartInstantMode"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChangeInstantMode },
                model: {
                  value: _vm.startInstantModeBoolean,
                  callback: function($$v) {
                    _vm.startInstantModeBoolean = $$v
                  },
                  expression: "startInstantModeBoolean"
                }
              }),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.Use24TimeFormat"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.Use24TimeFormat,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "Use24TimeFormat", $$v)
                  },
                  expression: "fields.Use24TimeFormat"
                }
              })
            ],
            1
          ),
          _c(
            "section",
            { staticClass: "mt-6" },
            [
              _c("div", { staticClass: "va-subtitle" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("policiesFields.HomeSettings")) + " "
                )
              ]),
              _c("va-switch", {
                attrs: {
                  text: _vm.$t("policiesFields.ShowQrCode"),
                  disabled: !_vm.isAdmin
                },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.fields.ShowQrCode,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "ShowQrCode", $$v)
                  },
                  expression: "fields.ShowQrCode"
                }
              }),
              _c("div", { staticClass: "va-subtitle-s" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("policiesFields.HomeApplications")) + " "
                )
              ]),
              _c("v-select", {
                staticClass: "mt-4",
                attrs: {
                  outlined: "",
                  dense: "",
                  attach: "",
                  items: _vm.homeActionOptionsFor("HomeAction1"),
                  "item-text": "text",
                  "item-value": "value",
                  label: _vm.$t("policiesFields.HomeAction1"),
                  "hide-details": "",
                  disabled: !_vm.isAdmin,
                  "item-disabled": "disabled"
                },
                on: { change: _vm.onChange },
                model: {
                  value: _vm.fields.HomeAction1,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "HomeAction1", $$v)
                  },
                  expression: "fields.HomeAction1"
                }
              }),
              _c("v-select", {
                staticClass: "mt-4",
                attrs: {
                  outlined: "",
                  dense: "",
                  attach: "",
                  items: _vm.homeActionOptionsFor("HomeAction2"),
                  "item-text": "text",
                  "item-value": "value",
                  label: _vm.$t("policiesFields.HomeAction2"),
                  "hide-details": "",
                  disabled: !_vm.isAdmin,
                  "item-disabled": "disabled"
                },
                on: { change: _vm.onChange },
                model: {
                  value: _vm.fields.HomeAction2,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "HomeAction2", $$v)
                  },
                  expression: "fields.HomeAction2"
                }
              }),
              _c("v-select", {
                staticClass: "mt-4",
                attrs: {
                  outlined: "",
                  dense: "",
                  attach: "",
                  items: _vm.homeActionOptionsFor("HomeAction3"),
                  "item-text": "text",
                  "item-value": "value",
                  label: _vm.$t("policiesFields.HomeAction3"),
                  "hide-details": "",
                  disabled: !_vm.isAdmin,
                  "item-disabled": "disabled"
                },
                on: { change: _vm.onChange },
                model: {
                  value: _vm.fields.HomeAction3,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "HomeAction3", $$v)
                  },
                  expression: "fields.HomeAction3"
                }
              }),
              _c("v-select", {
                staticClass: "mt-4",
                attrs: {
                  outlined: "",
                  dense: "",
                  attach: "",
                  items: _vm.homeActionOptionsFor("HomeAction4"),
                  "item-text": "text",
                  "item-value": "value",
                  label: _vm.$t("policiesFields.HomeAction4"),
                  "hide-details": "",
                  disabled: !_vm.isAdmin,
                  "item-disabled": "disabled"
                },
                on: { change: _vm.onChange },
                model: {
                  value: _vm.fields.HomeAction4,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "HomeAction4", $$v)
                  },
                  expression: "fields.HomeAction4"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }